;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { atom } from 'jotai'
import { DefaultShowsFilters, FilterObject } from '@/lib/types/showsFilters'

const showsFiltersAtom = atom<FilterObject>(DefaultShowsFilters)

export { showsFiltersAtom }
